import { maxWidthQueries } from '@operations/utils/useMediaQuery'
import React from 'react'
import styled from 'styled-components'

const ScrollInAnimation = styled.div`
  position: absolute;
  z-index: 100;
  animation: scrollIn 7s linear;
  animation-timing-function: cubic-bezier(0.2, 0.6, 1, 1);
  bottom: 0px;
  left: ${({ left }) => left};
  right: ${({ right }) => right};

  @keyframes scrollIn {
    0% {
      position: absolute;
      bottom: -1000px;
    }
    100% {
      position: absolute;
      bottom: 0px;
    }
  }
`

const ScrollAnimation = ({ children, left = 'auto', right = 'auto' }) => {
  return (
    <ScrollInAnimation left={left} right={right}>
      {children}
    </ScrollInAnimation>
  )
}
export default ScrollAnimation
